// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".q-radio__bg path{color:#ed885c!important}.error-message{color:#c10015;transition:all .3s ease-in-out;font-size:12px}", ""]);
// Exports
module.exports = exports;
